import {CanMatchFn} from '@angular/router';

const widgetPreviewFixtureRoutePattern = /^\/ai\/chatbots\/[^/]+\/widget-preview$/;
const widgetPreviewFixtureFixedRoute = '/ai/chatbots/widget-preview/product-card';

export function isWidgetPreviewFixtureUrl(href: string): boolean {
  const url = new URL(href);
  const isLocalHost = ['localhost', '127.0.0.1', '[::1]', '::1'].includes(url.hostname);

  return isLocalHost &&
    (url.pathname === widgetPreviewFixtureFixedRoute || widgetPreviewFixtureRoutePattern.test(url.pathname));
}

export const widgetPreviewFixtureCanMatch: CanMatchFn = () => {
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  return isWidgetPreviewFixtureUrl(window.location.href);
};
